import type { NotificationCategory, NotificationIcon } from "@loot-os/api-contract";

import { Icon } from "../../core/Icon.js";
import { cn } from "../../foundations/cn.js";
import { NOTIFICATION_CATEGORY_TINT, NOTIFICATION_ICONS } from "./notificationFormat.js";

export interface NotificationCategoryIconProps {
  category: NotificationCategory;
  icon: NotificationIcon;
  /** `sm` for a toast. */
  size?: "sm" | "md";
}

/** A notification's icon on its category's tint. Decorative: the words beside it say what it is. */
export function NotificationCategoryIcon({
  category,
  icon,
  size = "md",
}: NotificationCategoryIconProps) {
  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center",
        size === "md" ? "size-9 rounded-lg" : "size-6 rounded-sm",
        NOTIFICATION_CATEGORY_TINT[category],
      )}
    >
      <Icon icon={NOTIFICATION_ICONS[icon]} size={size === "md" ? 18 : 14} />
    </span>
  );
}
